import clsx from 'clsx';
import React from 'react';
import useSkipLink from './useSkipLink';

export type SkipLinkProps = {
  className?: string;
  label?: string;
  targetId?: string;
};

function SkipLink({ className, label, targetId = 'main-content' }: Readonly<SkipLinkProps>): JSX.Element {
  const { accessibleLabel, href, onClick } = useSkipLink({ label, targetId });

  return (
    <a className={clsx('skip-link', className)} href={href} onClick={onClick}>
      {accessibleLabel}
    </a>
  );
}

export default SkipLink;
